// extracted by mini-css-extract-plugin
export var actionButton = "_76-1";
export var actionButtons = "_76-2";
export var actions = "_76-0";
export var aiUnread = "_76-10";
export var alignCenter = "_76-h";
export var backWrapper = "_76-3";
export var cellContainer = "_76-4";
export var checkboxContainer = "_76-5";
export var contentContainer = "_76-6";
export var contentHeader = "_76-8";
export var conversationsTableWrapper = "_76-s";
export var draftReplyBadgeContainer = "_76-m";
export var dropdownItem = "_76-b";
export var dropdownItemsContainer = "_76-a";
export var dropdownTitle = "_76-c";
export var errorIcon = "_76-7";
export var filter = "_76-d";
export var gray = "_76-i";
export var headerActionButtons = "_76-e";
export var headerCheckboxContainer = "_76-f";
export var icon = "_76-j";
export var menuContainer = "_76-k";
export var noMoreTicketsIcon = "_76-12";
export var noMoreTicketsSubText = "_76-13";
export var oneLine = "_76-l";
export var optionsButton = "_76-n";
export var plus = "_76-o";
export var portalButtonsWrapper = "_76-g";
export var red = "_76-p";
export var scrolledTop = "_76-9";
export var search = "_76-q";
export var selectedConversationsCount = "_76-r";
export var spinner = "_76-t";
export var strong = "_76-u";
export var summaryCell = "_76-v";
export var tableContainer = "_76-11";
export var tagContainer = "_76-w";
export var threeDots = "_76-x";
export var twoLines = "_76-y";
export var unread = "_76-z";